import { render, staticRenderFns } from "./ReadingPerWords.vue?vue&type=template&id=07b7f676&scoped=true"
import script from "./ReadingPerWords.vue?vue&type=script&lang=js"
export * from "./ReadingPerWords.vue?vue&type=script&lang=js"
import style0 from "./ReadingPerWords.vue?vue&type=style&index=0&id=07b7f676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7f676",
  null
  
)

export default component.exports